export enum MAGAZINE_TYPE_BASE_URLS {
  CUSTOMER = '/customer',
  COLUMN = '/column',
  FEATURE = '/feature',
  CATEGORY = '/cms/categories',
}

export const MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES = 8
export const MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPE_ITEMS = 24

export enum MAGAZINE_TITLES {
  CUSTOMER = 'お客様の声',
  COLUMN = 'コラム・制作のコツ',
  FEATURE = '特集・キャンペーン一覧',
  CATEGORY = '商品特集ページ一覧'
}

export enum MAGAZINE_TYPES {
  CUSTOMER = 'customer',
  COLUMN = 'column',
  FEATURE = 'feature',
  CATEGORY = 'categories'
}
